export const categories = [
  { id: 'mobile', title: 'Мобильная разработка' },
  { id: 'systems', title: 'Системное программирование' },
  { id: 'other', title: 'Остальные проекты' },
];
